<div id=hlth-pkg-detail>
  <ng-container *ngIf="!openPayment && false">
    <div class="header border-bottom">
      <div class="font-primary-subtitle bold" *ngIf="!isReqRecieved">{{ 'title_confirm_pkg_req'|translate:'LABELS'}}
      </div>
      <div class="font-primary-subtitle bold" *ngIf="isReqRecieved">
        <span *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{ 'title_pkg_req_received' |translate:'LABELS'}}
        </span>
        <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'title_confirm_pkg_req'|translate:'LABELS'}} </span>
        <span *ngIf="paymentStatus=='R'">{{ 'title_confirm_pkg_req'|translate:'LABELS'}}</span>
      </div>
      <div (click)="closeConfirmModal()" class="float-left closeicon pointer">
        <img src="./assets/icons/close_black.svg">
      </div>
    </div>
    <div class="modal-pkg-content">
      <div class="card-review" *ngIf="isReqRecieved">
        <div class="card row-content">
          <img class="type-image img-alert" src="assets/icons/alert.svg" />
          <div class="font-light-small padding">
            <!-- {{'msg_request_alert'|translate }} -->
            <span *ngIf="paymentStatus=='S' || paymentStatus =='REQ'"> {{'msg_request_alert'|translate }}</span>
            <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'msg_failed' | translate}} </span>
            <span *ngIf="paymentStatus=='R'">{{'msg_retry' | translate}}</span>
          </div>
        </div>
      </div>
      <div class="card-review">
        <div class="card">
          <div class="card-head border-bottom">
            <span class="font-default-small bold">{{'ttl_selected_pkg'|translate:'LABELS'}}</span>
          </div>
          <div class="card-content">
            <div class="partitioner-details">
              <div class="image" *ngIf="detail && detail.imageURL">
                <img [src]="detail.imageURL">
                <!-- <app-practitioner-avatar [url]="this.detail.imageURL"></app-practitioner-avatar> -->
              </div>
              <div class="partitioner-content">
                <div class="title"> {{getTitle(concept.name)}} </div>
                <div class="font-light-small"> {{getSubTitle(concept.detail)}} </div>
              </div>
            </div>
            <div class="vertical-divider">
              <div class="divider"></div>
            </div>
            <div class="patient-details">
              <div class="image">
                <app-person-avatar [url]="pkgPrefer['patient']?pkgPrefer['patient']['imageurl']:''">
                </app-person-avatar>
              </div>
              <div class="partitioner-content">
                <div class="title">
                  {{pkgPrefer['patient']?pkgPrefer['patient']['personname']:''}}
                </div>
                <div class="font-light-small">
                  {{pkgPrefer['patient']?(pkgPrefer['patient']['relationshiptype'] | translate : 'RELATION'):''}}
                </div>
              </div>
            </div>
          </div>
          <div class="card-foot border-top">
            <div class="prefer-content">
              <div class="font-light-small">{{ 'lbl_preferred_date' | translate }}</div>
              <div class=" ">{{ pkgPrefer['preferredDate'] | moment:'DD MMM YYYY':'YYYY-MM-DD' }}</div>
            </div>
            <div class="prefer-content">
              <div class="font-light-small">{{ 'lbl_preferred_facility' | translate }}</div>
              <div class=" ">
                <!-- {{ pkgPrefer['facility'] | translate : 'LOCALE' : 'name'}} -->
                {{(pkgPrefer['facility']['facilityId']|facilityDetails:'facilityName') | translate : 'LOCALE' : 'name'}}
              </div>
            </div>
            <div class="prefer-content">
              <div class="font-light-small">{{ 'lbl_package_cost' | translate }}</div>
              <div class="bold ">{{currency_code}} {{ pkgPrefer['pkgCost'] }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-container" *ngIf="!isReqRecieved">
        <span *ngIf="appConfig.features.paymentGateway.enabled && appConfig.features.payableServices.services"
          style="background-color: whitesmoke !important;">
          <div *ngIf="pkgPrefer['facility'].controls.payableOnline">
            <button class="primary-button btn-customize" (click)="checkFunction('PAY', concept.name)">{{
              'btn_confirm_appt_pay' | translate }} {{currency_code}} {{ pkgPrefer['pkgCost'] }}</button>
          </div>
          <div *ngIf="!pkgPrefer['facility'].controls.payableOnline">
            <button class="primary-button btn-customize"
              (click)="request('NEWREQ', concept.name)">{{'lbl_confirm_req'|translate}}</button>
          </div>
        </span>
        <span *ngIf="!appConfig.features.paymentGateway.enabled || !appConfig.features.payableServices.services">
          <button class="primary-button btn-customize"
            (click)="request('NEWREQ', concept.name)">{{'lbl_confirm_req'|translate}}</button>
        </span>
        <!-- <button class="primary-button btn-customize" (click)="request('NEWREQ', concept.name)" >{{'lbl_confirm_req'|translate}}</button> -->
      </div>
      <div class="font-light-small padding align" *ngIf="!isReqRecieved"> {{ 'lbl_confirm_req_msg' | translate }} </div>
      <div class="card-review" *ngIf="isReqRecieved && paymentStatus !='REQ' ">
        <div class="card">
          <div class="card-head border-bottom">
            <span class="font-default-small bold">{{'transaction_details'|translate:'LABELS'}}</span>
          </div>
          <div class="card-foot">
            <div class="prefer-content">
              <div class="font-light-small">{{'transaction_id'|translate:'LABELS'}}</div>
              <div>{{paymentData['transactionId']||'-'}}</div>
            </div>
            <div class="prefer-content">
              <div class="font-light-small">{{'gateway_ref_no'|translate:'LABELS'}}</div>
              <div>{{paymentData['gatewayRefId']||'-'}}</div>
            </div>
            <div class="prefer-content">
              <div class="font-light-small">{{'bank_ref_no'|translate:'LABELS'}}</div>
              <div>{{paymentData['bankRefId']||'-'}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-container" *ngIf="isReqRecieved">
        <button class="button-transparent btn-customize" (click)="closeConfirmModal()">{{'btn_close'|translate
          }}</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!openPayment && !isBookingSubService">
    <div class="header border-bottom spac-btw">
      <div class="flex">
        <div (click)="closeModal('BACK')" class="float-left closeicon pointer">
          <img src="./assets/icons/arrow.svg">
        </div>
        <div class="font-primary-subtitle bold" *ngIf="!isReqRecieved">{{ 'title_review'|translate:'LABELS'}} </div>
        <div class="font-primary-subtitle bold" *ngIf="isReqRecieved">
          <span *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{ 'title_pkg_req_received' |translate:'LABELS'}}
          </span>
          <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'title_confirm_pkg_req'|translate:'LABELS'}} </span>
          <span *ngIf="paymentStatus=='R'">{{ 'title_confirm_pkg_req'|translate:'LABELS'}}</span>
        </div>
      </div>
      <div (click)="closeModal('CLOSE')" class="float-right closeicon pointer">
        <img src="./assets/icons/close_black.svg">
      </div>
    </div>

    <div class="modal-pkg-content">
      <div class="card-review-alert" *ngIf="isReqRecieved">
        <div class="success-container">
          <img src="assets/icons/health-package/check.svg" *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">
          <img src="assets/icons/task/error.svg" *ngIf="paymentStatus=='F'|| paymentStatus=='P' || paymentStatus=='R'">
          <span class="font-default-small bold" *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{'cal_modal_success_msg'|translate:'LABELS'}}</span>
          <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'msg_failed' | translate}} </span>
          <span *ngIf="paymentStatus=='R'">{{'msg_retry' | translate}}</span>
        </div>
        <div class="info-container">
          <div class="font-default-small col-9">{{'appt_dtl_msg_download_app_now'|translate:'LABELS'}}</div>
          <div class="logo-container col-3">
            <div class="logo">
              <img class="type-image" src="assets/images/app-googleplay.png" alt="">
            </div>
            <div class="logo">
              <img class="type-image" src="assets/images/apple_play.png" alt="">
            </div>
            <div class="logo" *ngIf="false">
              <img class="type-image" src="assets/images/apple_play.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div class="new-card-review" [ngClass]="{'new-card-reschedule': isReschedule}">
        <div class="col">
          <div class="info-msg-text-wrapper" *ngIf="!isReschedule">
            <div class="image">
              <img src="assets/icons/slot/info.svg">
            </div>
            <div class="info-text">
              <span class="info-text-msg">{{'package_notes' | translate}}</span>
            </div>
          </div>
          <app-appt-dtl-card [apptInfo]="requestInfo" [type]="'PACKAGEPREVIEW'" [flowType]="requestInfo['flowType']"
            (editAction)="switchActions($event)" [isEditApplicable]="isEditApplicable"></app-appt-dtl-card>
        </div>
        <div class="col payment-detail-col" *ngIf="!isReschedule">
          <div class="referral-code" [ngClass]="{ 'default-bg':  !enterReferral , 'referral-card': enterReferral}" *ngIf="enableReferralCode">
              <p class="prim-ttl-txt" (click)="enterReferral = !enterReferral" *ngIf="!enterReferral">{{'appt_dtl_ttl_do_you_have_referral_code'|translate:'LABELS'}}</p>
              <ng-container *ngIf="enterReferral">
                  <p class="subtitle lbl">{{'appt_dtl_ttl_referral_code'|translate:'LABELS'}}</p>
                  <div class="referral-input">
                      <input class="ref-input" [type]="referralControl?referralControl.type:'text'" (input)="onTextInput($event)" placeholder="{{ 'appt_dtl_placeholder_enter' | translate}}" [(ngModel)]="referralCode"
                      [minLength]="referralControl?referralControl.minLength:null"
                      [maxLength]="referralControl?referralControl.maxLength:null"/>
                      <div class="close float-right closeicon cursor-pointer" (click)="removeReferral()"
                          *ngIf="referralCode">
                          <img src="./assets/icons/close_grey.svg">
                      </div>
                  </div>
              </ng-container>
          </div>
          <!-- <div class="nuhdeek-points-card" *ngIf="isEnablePoints && ((pointsType == 'PAYMENT' && (canPay || chargeDetails.isPointsApplied)) || (pointsType == 'DISCOUNT'))">
            <p>{{'Redeem your Nuhdeek Loyalty points'}}</p>
            <app-altpayment-input [input]="'POINTS'" [totalAmount]="chargeDetails.totalAmount"
              [netPayable]="chargeDetails._payableWithoutPoints" [promoCodeDetails]="chargeDetails['promoCodeDetails']"
              (pointsApplied)="pointsApplied($event)" #points
              (applyingPoints)="applyingPoints($event)"></app-altpayment-input>
          </div> -->
          <!-- <div *ngIf="(isEnablePromo || (isEnablePoints && pointsType == 'DISCOUNT'))" id="finddocpromodiv">
            <ng-container *ngIf="(canPay && chargeDetails && chargeDetails.discountDetails && chargeDetails.discountDetails.applicable && !chargeDetails.isFreeFollowUp) || (chargeDetails.isPromoApplied || (pointsType == 'DISCOUNT' && chargeDetails.isPointsApplied))">
              <app-promo-input [patientPayable]="chargeDetails.totalAmount" [selections]="requestInfo"
                [discountDetails]="chargeDetails.discountDetails" (applyingDiscount)="applyingPromoCode($event)"
                (appliedDiscount)="appliedPromocode($event)" [selectedServices]="selectedServicesDtl" [selections]="selections"
                [isEnablePoints]="isEnablePoints && pointsType == 'DISCOUNT'" [isEnablePromo]="isEnablePromo"
                [parsedChargeInfo]="chargeVatDetails ? chargeVatDetails: null">
              </app-promo-input>
            </ng-container>
          </div>
          <div class="coupon-card" *ngIf="isEnableCoupon && (canPay || chargeDetails.isCouponApplied)">
            <app-altpayment-input [input]="'COUPON'" [totalAmount]="chargeDetails.totalAmount"
              [netPayable]="chargeDetails._payableWithoutCoupon" [promoCodeDetails]="chargeDetails['promoCodeDetails']"
              (couponApplied)="couponApplied($event)" #coupon
              (applyingCoupon)="applyingCouponCode($event)"></app-altpayment-input>
          </div> -->
    <ng-container *ngIf="((canPay || chargeDetails.isPointsApplied) && isEnablePoints && !isReschedule && !isBookingSubService && chargeDetails && pointsType == 'PAYMENT') || ((isEnablePromo || (isEnablePoints && pointsType == 'DISCOUNT')) && !isReschedule && !isBookingSubService && ((canPay && chargeDetails && chargeDetails.discountDetails && chargeDetails.discountDetails.applicable) || (chargeDetails.isPromoApplied || (pointsType == 'DISCOUNT' && chargeDetails.isPointsApplied)))) || (isEnableCoupon && !isReschedule && !isBookingSubService && chargeDetails && (canPay || chargeDetails.isCouponApplied))">
        <app-alternate-payment
          [order]="'POINTS#PROMOCOUPON'"
          [isDiscountOnApptBooking]="true"
          [patientPayable]="chargeDetails.totalAmount"
          [selections]="selections"
          [selectedServices]="selectedServicesDtl"
          [discountDetails]="chargeDetails.discountDetails"
          [parsedChargeInfo]="chargeVatDetails ? chargeVatDetails: null"
          [parentApplyingCode]="isApplyingCode"
          [isDiscountApplied]="chargeDetails.isGeneralDiscountApplied"
          [computedDetail]="computedDetail"
          [apptDetail]="slot"
          [chargeDetails]="chargeDetails"
          [couponAdditionalParams]="couponAdditionalParams"
          [isEnablePoints]="isEnablePoints && ((pointsType == 'PAYMENT' && (canPay || chargeDetails.isPointsApplied)) || (pointsType == 'DISCOUNT'))"
          [isEnablePromo]="isEnablePromo && (canPay && chargeDetails && chargeDetails.discountDetails && chargeDetails.discountDetails.applicable) || chargeDetails.isPromoApplied"
          [isEnableCoupon]="isEnableCoupon && (canPay || chargeDetails.isCouponApplied)"
          (applyingAltPayment)="applyingAltPaymentCode($event)"
          (appliedAltPayment)="appliedAltPayment($event)"
          #altPayment
        >
        </app-alternate-payment>
    </ng-container>
          <ng-container *ngIf="!fetchingCharge && !isReschedule">
            <p class="font-default-small bold side-hdr">{{'onspot_req_lbl_summary_of_charges'|translate:'LABELS'}}</p>
            <div class="payment-details">
              <div class="card">
                <div class="card-content" *ngIf="flowType == 'HEALTHPKG' || (flowType == 'RESCHEDULE' && prevPayment && prevPayment['status']!='PAID')">
                  <div class="payment-group">
                    <div class="payment-content border-bottom" *ngIf="!chargeVatDetails">
                      <div class="subheader-font">{{'onspot_req_lbl_consult_charges'|translate:'LABELS'}}
                      </div>
                      <div class="prim-ttl-txt bold">
                        <app-display-currency [amount]="chargeDetails.payableAmount"></app-display-currency>
                      </div>
                    </div>
                    <div class="payment-content border-bottom"
                      *ngIf="chargeVatDetails && chargeVatDetails.baseServiceAmount">
                      <div class="subheader-font">{{'onspot_req_lbl_consult_charges'|translate:'LABELS'}}
                      </div>
                      <div class="prim-ttl-txt bold">
                        <app-display-currency [amount]="chargeVatDetails.baseServiceAmount"></app-display-currency>
                      </div>
                    </div>
                    <div class="payment-content border-bottom">
                      <div class="subheader-font">{{'appt_dtl_pmt_details_category'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle">
                        {{(billingGroup ? billingGroup : 'CASH') | translate}}
                      </div>
                    </div>
                    <div class="payment-content border-bottom"
                      *ngIf="chargeDetails.isPromoApplied && chargeDetails.promoDiscount > 0">
                      <div class="subheader-font">{{'lbl_Promocode'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle">
                        <app-display-currency [amount]="chargeDetails.promoDiscount"></app-display-currency>
                      </div>
                    </div>
                    <div class="payment-content border-bottom"
                      *ngIf="chargeDetails.isPointsApplied && chargeDetails.pointsDiscount > 0">
                      <div class="subheader-font">{{'lbl_points'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle">
                        <app-display-currency [amount]="chargeDetails.pointsDiscount"
                          [prefix]="'-'"></app-display-currency>
                      </div>
                    </div>

                    <div class="payment-content border-bottom"
                      *ngIf="chargeVatDetails && chargeVatDetails.vatDisplayAmount">
                      <div class="subheader-font">{{'appt_req_lbl_vat_amount'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle">
                        <app-display-currency [amount]="chargeVatDetails.vatDisplayAmount"></app-display-currency>
                      </div>
                    </div>
                    <div class="payment-content border-bottom"
                      *ngIf="chargeDetails.isCouponApplied && chargeDetails.couponDiscount > 0">
                      <div class="subheader-font">{{'lbl_coupon'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle">
                        <app-display-currency [amount]="chargeDetails.couponDiscount"></app-display-currency>
                      </div>
                    </div>
                    <div class="payment-content">
                      <div class="subheader-font bold">{{'onspot_req_lbl_total_to_be_paid'|translate:'LABELS'}}
                      </div>
                      <div class="def-subtitle bold">
                        <app-display-currency [amount]="chargeDetails.netPayable"></app-display-currency>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-content"
                  *ngIf="(flowType == 'RESCHEDULE' && prevPayment && prevPayment['status']=='PAID')">
                  <div class="payment-group">
                    <div class="payment-content border-bottom">
                      <div class="subheader-font">{{'prev_amt_paid'|translate:'LABELS'}}
                      </div>
                      <div class="prim-ttl-txt bold">
                        <app-display-currency [amount]="prevPaymentCost"></app-display-currency>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="payment-methods payment-details" *ngIf="payType=='X'">
              <div class="card">
                <div class="card-head def-subtitle border-bottom">
                  <span class="font-default-small bold">{{'policy_details'|translate:'LABELS'}}</span>
                </div>
                <div class="card-content">
                  <div class="payment-group">
                    <div class="payment-content border-bottom">
                      <div class="font-default-small">{{'appt_confirm_lbl_policy_name'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">{{patientInsurance['policyTypeDesc']}}</div>
                    </div>
                    <div class="payment-content border-bottom">
                      <div class="font-default-small">{{'appt_confirm_lbl_policy_no'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">{{patientInsurance['policyno']}}</div>
                    </div>
                    <div class="payment-content ">
                      <div class="font-default-small">{{'appt_confirm_lbl_expire_date'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">
                        {{patientInsurance['policyExpireDate']|moment:'DD MMM YYYY':'DD/MM/YYYY'}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="payment-methods payment-details" *ngIf="actualInsuranceDetails">
              <div class="card">
                <div class="card-head def-subtitle border-bottom">
                  <span class="font-default-small bold">{{'policy_details'|translate:'LABELS'}}</span>
                </div>
                <div class="card-content">
                  <div class="payment-group">
                    <div class="payment-content border-bottom">
                      <div class="font-default-small">{{'appt_confirm_lbl_policy_name'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">{{actualInsuranceDetails['policyTypeDesc']}}</div>
                    </div>
                    <div class="payment-content border-bottom">
                      <div class="font-default-small">{{'appt_confirm_lbl_policy_no'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">{{actualInsuranceDetails['policyno']}}</div>
                    </div>
                    <div class="payment-content">
                      <div class="font-default-small">{{'appt_confirm_lbl_expire_date'|translate:'LABELS'}}</div>
                      <div class="font-default-small bold">
                        {{actualInsuranceDetails['policyExpireDate']|moment:'DD MMM YYYY':'DD/MM/YYYY'}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="followup-text prim-ttl-txt" *ngIf="freeFollowUpYn">
              <img class="type-image" src="assets/icons/info.svg" />
              {{'you_are_eligible_for_a_followup_day'|translate}}
            </div>
            <div class="policy-validation-card-container" *ngIf="policyValidation">
              <div class="policy-validation-card card">
                <div class="card-head def-subtitle bold border-bottom">
                  {{'lbl_head_policy_details' | translate}}
                </div>
                <div class="card-content">
                  <div class="success-failure-img">
                    <img src="./assets/icons/insurance_icons/success.svg" *ngIf="!policyValidation.promptCashAppt">
                    <img src="./assets/icons/insurance_icons/alert.svg" *ngIf="policyValidation.promptCashAppt">
                  </div>
                  <div class="validation-text">
                    <div class="policy-name bold">{{policyValidation.promptLabels.title | translate}}</div>
                    <div class="policy-status font-light-small" *ngIf="!policyValidation.promptCashAppt">
                      {{'lbl_insurance_applied_success' | translate}}</div>
                    <div class="policy-status font-light-small" *ngIf="policyValidation.promptCashAppt">
                      {{'lbl_insurance_applied_failure' | translate}}</div>
                  </div>
                </div>
              </div>
            </div> -->
          </ng-container>
          <ng-container *ngIf="fetchingCharge">
            <div class="page-loader-container">
              <div class="pageloader">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="modal-footer" *ngIf="packageOnlyFlow || (!packageOnlyFlow && packageConfirmView)">
      <div class="btn-container" *ngIf="!isReschedule">
        <span *ngIf="canPay">
          <button class="primary-button btn-customize" [disabled]="isApplyingCode || isAutoApplyingCoupon" [ngClass]="{'disabledButton': isApplyingCode || isAutoApplyingCoupon }" (click)="submitRequest('PAY')">{{'btn_confirm_appt_pay' | translate }} {{ this.chargeDetails.netPayable }} {{currency_code}}</button>
        </span>
        <span *ngIf="!canPay">
          <button class="primary-button btn-customize" (click)="submitRequest('REQ')" [disabled]="isApplyingCode || isAutoApplyingCoupon">{{'lbl_submit'|translate}}</button>
        </span>
      </div>
      <!-- <div class="btn-container" *ngIf="isReqRecieved">
        <button class="primary-button" (click)="closeModal('CLOSE')">{{'btn_back_to_home'|translate }}</button>
      </div> -->
    </div>
    <div class="modal-footer" *ngIf="isReschedule">
      <div class="btn-container">
        <span *ngIf="!canPay">
          <button class="primary-button btn-customize" (click)="initReschedule()" [disabled]="isApplyingCode || isAutoApplyingCoupon">{{'lbl_submit'|translate}}</button>
        </span>
      </div>
      <!-- <div class="btn-container" *ngIf="isReqRecieved">
        <button class="primary-button" (click)="closeModal('CLOSE')">{{'btn_back_to_home'|translate }}</button>
      </div> -->
    </div>
  </ng-container>

    <ng-container *ngIf="isBookingSubService">
    <div class="header border-bottom spac-btw">
      <div class="flex">
        <div (click)="closeModal('BACK')" class="float-left closeicon pointer">
          <img src="./assets/icons/arrow.svg">
        </div>
        <div class="font-primary-subtitle bold" *ngIf="!isReqRecieved">{{ 'title_review'|translate:'LABELS'}} </div>
        <div class="font-primary-subtitle bold" *ngIf="isReqRecieved">
          <span *ngIf="paymentStatus=='S' || paymentStatus =='REQ'">{{ 'title_pkg_req_received' |translate:'LABELS'}}
          </span>
          <span *ngIf="paymentStatus=='F'|| paymentStatus=='P'"> {{ 'title_confirm_pkg_req'|translate:'LABELS'}} </span>
          <span *ngIf="paymentStatus=='R'">{{ 'title_confirm_pkg_req'|translate:'LABELS'}}</span>
        </div>
      </div>
      <div (click)="closeModal('CLOSE')" class="float-right closeicon pointer">
        <img src="./assets/icons/close_black.svg">
      </div>
    </div>

    <div class="modal-pkg-content">
      <div class="pkg-card-review" *ngIf="requestInfo && groupedServices">
        <app-appt-dtl-card class="appt-dtl-card" [apptInfo]="requestInfo" [type]="'PACKAGEPREVIEW'" [flowType]="requestInfo['flowType']"
            (editAction)="switchActions($event)" [groupedServices]="groupedServices" [selectedPackage]="selectedPackage"></app-appt-dtl-card>
      </div>
    </div>

    <div class="modal-footer">
      <div class="btn-container">
        <span>
          <button class="primary-button btn-customize" (click)="submitRequest('REQ')">{{'lbl_submit'|translate}}</button>
        </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="openPayment">
    <div class="header border-bottom">
      <div class="font-primary-subtitle bold">{{'title_confirm_pkg_req'|translate}}
      </div>
      <div (click)="closeConfirmModal()" class="float-right closeicon pointer">
        <img src="./assets/icons/close_black.svg">
      </div>
    </div>
    <div class="modal-payment-content">
      <app-payment-checkout></app-payment-checkout>
    </div>
  </ng-container>
</div>

<div *ngIf="isSubmitting" class="main-warpper">
  <div class="app-loading">
    <div class="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>